import React, { createContext, useEffect, useState } from 'react';
import { Layout } from 'antd';
import { useBreadcrumbRoutes, Wrapper } from '@maxtropy/components';
import styles from './index.module.scss';
import DragResize from '@/components/DragResize';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import EnergyTree from './EnergyTree';
import UnitDetail from './UnitDetail';
import dayjs, { Dayjs } from 'dayjs';
import { EnergyUnitItem, UnitBasicProps } from '@/api/energyUnitDashboard';
import EnergyAnalysisOverview from './EnergyAnalysisOverview';
import {
  apiV2EnergyMediumPhysicalUnitByUnitGroupPost,
  V2EnergyMediumPhysicalUnitByUnitGroupPostResponse,
} from '@maxtropy/device-customer-apis-v2';

const { Content, Sider } = Layout;

export const EnergyUsageCostContext = createContext<{
  groupId?: number;
  unitId?: number;
  hasChildren?: boolean;
  setGroupId?: (groupId: number) => void;
  setUnitId?: (unitId: number | undefined) => void;
  showDetail?: boolean;
  setShowDetail?: (showDetail: boolean) => void;
  oneLevelUnits?: UnitBasicProps[];
}>({});

const EnergyUsageCostKanban: React.FC = () => {
  const [openSider, setOpenSider] = useState(true);
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const [groupId, setGroupId] = useState<number>();
  const [unitId, setUnitId] = useState<number>();
  const [unitList, setUnitList] = useState<any>([]);

  const [unitPath, setUnitPath] = useState<string>('');
  const [hasChildren, setHasChildren] = useState<boolean>();
  const [defaultData, setDefaultData] = useState<EnergyUnitItem[]>([]);
  const [energyUnitList, setEnergyUnitList] = useState<V2EnergyMediumPhysicalUnitByUnitGroupPostResponse['data']>();

  // 初始值
  const [siderWidth, setSiderWidth] = useState(260);
  // 拖拽状态
  const [dragStatus, setDragStatus] = useState(false);

  const dragChange = (width: number) => {
    if (openSider) {
      setSiderWidth(width);
    }
  };

  // 查询单位
  useEffect(() => {
    if (!groupId) return;
    apiV2EnergyMediumPhysicalUnitByUnitGroupPost({ energyUnitGroupId: groupId }).then(res => {
      setEnergyUnitList(res.data);
    });
  }, [groupId]);

  return (
    <Wrapper routes={breadcrumbRoutes?.routes} hasPadding={false}>
      <EnergyUsageCostContext.Provider
        value={{
          groupId,
          unitId,
          setGroupId,
          setUnitId,
          showDetail,
          setShowDetail,
          hasChildren,
          oneLevelUnits: unitList,
        }}
      >
        <Layout className={styles.layout}>
          <Sider
            className={styles.siderDemo}
            width={openSider ? siderWidth : 0}
            style={{ transition: dragStatus ? 'none' : 'all 0.2s' }}
          >
            <DragResize init={260} dragChange={dragChange} dragStatus={setDragStatus} />
            <EnergyTree
              setNodePath={path => setUnitPath(path)}
              defaultData={defaultData}
              setHasChildren={setHasChildren}
              setDefaultData={setDefaultData}
              setOneLevelUnits={items => setUnitList(items)}
            />
          </Sider>
          <Content
            className={styles.content}
            style={{
              marginLeft: openSider ? 10 : 0,

              backgroundColor: 'var(--mx-module-bg-color)',
            }}
          >
            <div className="toggleBtn" style={{ left: openSider ? -30 : 0 }} onClick={() => setOpenSider(!openSider)}>
              {openSider ? <LeftOutlined /> : <RightOutlined />}
            </div>
            <div style={{ height: 'calc(100vh - 128px)', overflowY: 'auto' }}>
              {showDetail ? (
                // 详情页
                <UnitDetail unitPath={unitPath} defaultData={defaultData} energyUnitList={energyUnitList} />
              ) : (
                <>
                  {/* 用能分析总览 */}
                  <EnergyAnalysisOverview groupId={groupId} />
                </>
              )}
            </div>
          </Content>
        </Layout>
      </EnergyUsageCostContext.Provider>
    </Wrapper>
  );
};

export default EnergyUsageCostKanban;
